import { jsx } from "react/jsx-runtime";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { validateTidalLicense } from "../../base/index.js";
function EventAvailable(props) {
  return /* @__PURE__ */ jsx(
    EventAvailableIcon,
    {
      "data-testid": "EventAvailable",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EventAvailable",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
EventAvailable.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "EventAvailable"
};
validateTidalLicense();
export {
  EventAvailable
};
//# sourceMappingURL=EventAvailable.js.map
